import React, { useContext, useState } from "react";
import {
  Button,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Box,
  Text,
  VStack,
  HStack,
  Flex,
} from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import { appRequest } from "routes";
import { CloseIcon } from "@chakra-ui/icons";
import { exportToExcels } from "./utils/functions";

const MailModal = ({
  isOpen,
  onClose,
  fieldName,
  setFieldName,
  transformedData,
  values,
  sendMail,
  fileData,
  setFileData,
  setFinalResults,
}: any) => {
  const [currentEmail, setCurrentEmail] = useState<string>(""); // Current input value
  const { toastNotify } = useContext(AppContext);

  const handleClose = () => {
    setFieldName([]);
    setCurrentEmail(""); // Reset input
    onClose();
  };

  const handleAddEmail = () => {
    if (currentEmail.trim() !== "") {
      setFieldName((prevEmails: any) => [...prevEmails, currentEmail.trim()]); // Add current email to the array
      setCurrentEmail(""); // Clear the input after adding
    } else {
      toastNotify({
        title: `Invalid email.`,
        message: "Please enter a valid email.",
        type: "warning",
      });
    }
  };

  const handleMails = (name: string) => {
    setFieldName(fieldName.filter((it: any) => name !== it));
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      isCentered
      size={{ base: "xs", md: "md" }}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          color="teal.300"
          fontSize={{ base: "lg", md: "2xl" }}
          fontWeight="700"
        >
          Enter Email(s)
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4}>
            <HStack width="100%">
              <Input
                placeholder={"Enter email"}
                value={currentEmail}
                onChange={(e) => setCurrentEmail(e.target.value)}
              />
              <Button
                onClick={handleAddEmail}
                color={"white"}
                bg={"teal.300"}
                _hover={{ bg: "teal.400" }}
              >
                Add
              </Button>
            </HStack>
            {/* Display list of emails */}
            <Box width="100%">
              {fieldName?.length > 0 ? (
                <Box>
                  <Text fontWeight="bold">Added Emails:</Text>
                  {fieldName.map((email: any, index: any) => (
                    <Flex gap={4} key={index} justifyContent="space-between">
                      <Text key={index}>- {email}</Text>

                      <Text
                        color="red"
                        onClick={() => handleMails(email)}
                        fontSize="sm"
                        cursor="pointer"
                      >
                        Delete
                      </Text>
                    </Flex>
                  ))}
                </Box>
              ) : (
                <Text>No emails added yet.</Text>
              )}
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="green"
            onClick={() => {
              const clonedData = JSON.parse(JSON.stringify(transformedData));
              exportToExcels(
                clonedData
              );
              handleClose();
            }}
          >
            Send
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default MailModal;
